import { Button, Table, Title } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

import { RouteList } from '@/shared/constants';
import { useProjectPath } from '@/shared/projects/project-path';

import {
  useGetCategory,
  useGetCategoryBooks,
} from '../model/category-detail-page.cases';
import styles from './category-detail-page.module.scss';

const CategoryDetailPage = () => {
  const navigate = useNavigate();
  const withProject = useProjectPath();
  const getCategoryQuery = useGetCategory();
  const getCategoryBooksQuery = useGetCategoryBooks();

  function goToEditCategory() {
    const categoryId = getCategoryQuery.data?.id;

    if (categoryId) {
      navigate(withProject(RouteList.EDIT_CATEGORY(String(categoryId))));
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>
          <Title order={1} size={44} className={styles.title}>
            {getCategoryQuery.data?.title}
          </Title>
          <Button
            variant="outline"
            className={styles.editButton}
            onClick={goToEditCategory}
          >
            Редактировать категорию
          </Button>
        </div>
        <img
          src={getCategoryQuery.data?.imgUrl}
          alt="preview"
          className={styles.preview}
        />
      </div>

      <div className={styles.books}>
        <p className={styles.booksTitle}>Список книг</p>
        <Table withTableBorder flex={1}>
          <Table.Thead>
            <Table.Tr>
              <Table.Th className={styles.tableHeadCell}>Обложка</Table.Th>
              <Table.Th className={styles.tableHeadCell}>Название</Table.Th>
              <Table.Th className={styles.tableHeadCell}>Автор</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {getCategoryBooksQuery.data?.books?.map((book) => (
              <Table.Tr
                key={book.id}
                className={styles.tableRow}
                onClick={() =>
                  navigate(
                    withProject(RouteList.BOOK_DETAILS(book.id.toString())),
                  )
                }
              >
                <Table.Td width="20%">
                  <img
                    src={book.imgUrl}
                    alt="preview"
                    className={styles.tableBookPreview}
                  />
                </Table.Td>
                <Table.Td className={styles.tableBookName} width="50%">
                  {book.title}
                </Table.Td>
                <Table.Td className={styles.tableBookAuthorName} width="30%">
                  {book.author}
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
        {/* <Button variant="outline" onClick={() => navigate(RouteList.BOOKS)}>
          Открыть полный список
        </Button> */}
      </div>
    </div>
  );
};

export default CategoryDetailPage;
